import React, { useState, useEffect, ReactElement } from "react";

import { useParams } from "react-router-dom";

import Menu from "../../../components/member/parts/Menu";
import Header from "../../../components/member/parts/Header";

import useMailTemplateState from "./useMailTemplateState.ts";
import useAuthState from "../../../auth/useAuthState";

import "../../../styles/mail.css";
//import "../styles/dashboard.css";
//import "../../../styles/customer.css";

function MailTemplateListApp() {
    const { accommodation_id } = useParams();
    const [list, setList] = useState<Array<ReactElement> | null>(null);
    const { token, getToken } = useAuthState();
    const { mail_template_updated_at, mail_template_list, getMailTemplateList } = useMailTemplateState();

    useEffect(() => {
        if (mail_template_updated_at && mail_template_list) {
            console.log(mail_template_list);
            setList(
                mail_template_list.map((template) => {
                    return (
                        <tr key={"mail_template_" + template.id}>
                            <td className="free">{template.title}</td>
                            <td className="w130">{template.getSendTypeLabel()}</td>
                            <td className="w130">{template.from_address}</td>
                            <td className="w80">
                                <a href={"/m/accommodation/" + accommodation_id + "/mail/template/" + template.id}>修正</a>
                            </td>
                        </tr>
                    );
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mail_template_updated_at]);

    useEffect(() => {
        if (token && accommodation_id) {
            getMailTemplateList(token, accommodation_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="inner">
            <main className="main">
                <Menu selected="accommodation" accommodation_id={accommodation_id} />
                <div className="main-content">
                    <Header accommodation_id={accommodation_id} id="calendar" />
                    <div className="free-pannel scrollable-vertical">
                        <section className="pannel">
                            <div className="section-header">
                                <div className="title">メールテンプレート一覧</div>
                                <div className="select"></div>
                                <div className="right-menu">
                                    <div
                                        className="inline-link"
                                        onClick={() => (window.location.href = "/m/accommodation/" + accommodation_id + "/mail/template/create")}
                                    >
                                        <i className="fas fa-plus-circle"></i> 新規作成
                                    </div>
                                </div>
                            </div>

                            <table className="mail-template-table">
                                <thead>
                                    <tr>
                                        <th className="free">テンプレート名</th>
                                        <th className="w130">テンプレートタイプ</th>
                                        <th className="w130">送信メールアドレス</th>
                                        <th className="w80">修正</th>
                                    </tr>
                                </thead>
                                <tbody>{list}</tbody>
                            </table>
                        </section>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default MailTemplateListApp;
